import React,{useRef,useState} from 'react';
import {FiEdit2,FiCheck,FiX} from 'react-icons/fi';

export default function ProjectTitle({title,disabled,onSave}) {
  const [editing,setEditing]=useState(false),[draft,setDraft]=useState(title);
  const [saving,setSaving]=useState(false),[error,setError]=useState('');
  const inFlight=useRef(false),button=useRef(null);
  const finish=(focus=false)=>{setEditing(false);setError('');if(focus)requestAnimationFrame(()=>button.current?.focus());};
  const save=async(focus=false)=>{
    if(inFlight.current || disabled)return;
    const name=draft.trim();
    if(!name){setError('Enter a project name.');return;}
    if(name===title){finish(focus);return;}
    inFlight.current=true;setSaving(true);setError('');
    try{if(await onSave(name)===false){setError('Could not save. Please try again.');return;}finish(focus);}
    catch{setError('Could not save. Please try again.');}
    finally{inFlight.current=false;setSaving(false);}
  };
  if(!editing)return <button ref={button} className="project-rename" title="Rename project" disabled={disabled} onClick={()=>{setDraft(title);setError('');setEditing(true);}}><span>{title}</span><FiEdit2/></button>;
  return <form className="project-title-editor" aria-label="Rename project" aria-busy={saving} onSubmit={event=>{event.preventDefault();save(true);}} onBlur={event=>{if(!event.currentTarget.contains(event.relatedTarget))save();}}>
    <div className="project-title-input-row">
      <input autoFocus aria-label="Project name" aria-invalid={!!error} aria-describedby={error?'project-title-error':undefined} maxLength={120} value={draft} readOnly={saving} onFocus={event=>event.target.select()} onChange={event=>{setDraft(event.target.value);setError('');}} onKeyDown={event=>{if(event.key==='Escape'){event.preventDefault();event.stopPropagation();if(!inFlight.current)finish(true);}if(event.key==='Enter'&&event.nativeEvent.isComposing)event.preventDefault();}}/>
      <button type="submit" title="Save name" aria-label="Save project name" disabled={disabled||saving||!draft.trim()}><FiCheck/></button>
      <button type="button" title="Cancel" aria-label="Cancel rename" disabled={saving} onClick={()=>finish(true)}><FiX/></button>
    </div>
    {error && <span id="project-title-error" className="project-title-error" role="alert">{error}</span>}
    {saving && <span className="project-title-saving" role="status">Saving…</span>}
  </form>;
}
